import { render, staticRenderFns } from "./Calorias-Diarias.vue?vue&type=template&id=a13832dc&scoped=true&"
import script from "./Calorias-Diarias.vue?vue&type=script&lang=ts&"
export * from "./Calorias-Diarias.vue?vue&type=script&lang=ts&"
import style0 from "./Calorias-Diarias.vue?vue&type=style&index=0&id=a13832dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13832dc",
  null
  
)

export default component.exports